<template>
  <rabbey-base-drawer
    :title="titleRow"
    size="70%"
    :drawer.sync="drawer"
    v-loading.fullscreen.lock="loading"
    :with-header="true"
    v-bind="$attrs"
    @close="OnClose"
    @closed="OnClose"
  >
    <div class="statustags">
      <el-tooltip
        placement="top-start"
        :content="
          this.invoicespending === 1
            ? 'Una Factura Vencida'
            : 'Mas de una Facturas Vencidas'
        "
      >
        <el-tag
          size="small"
          :type="this.invoicespending > 1 ? 'success' : 'danger'"
          >Cuentas x Pagar Vencidas</el-tag
        >
      </el-tooltip>
      <el-tooltip
        placement="top-start"
        :content="
          data.ContractStatus >= 1
            ? 'Contrato del cliente abierto'
            : 'Contrato del cliente cerrado'
        "
      >
        <el-tag
          size="small"
          :type="data.ContractStatus >= 1 ? 'success' : 'danger'"
          >Contrato</el-tag
        >
      </el-tooltip>

      <el-tooltip
        :content="
          data.StatusNavixy || (NcfStatu.Status && NcfStatu.EsNcf)
            ? 'Servicio en Plataforma activo'
            : 'Servicio en Plataforma desactivado'
        "
        placement="top-start"
        effect="dark"
      >
        <el-tag
          size="small"
          :type="
            data.StatusNavixy || (NcfStatu.Status && NcfStatu.EsNcf)
              ? 'success'
              : 'danger'
          "
          >SP</el-tag
        >
      </el-tooltip>
    </div>
    <el-row>
      <el-col>
        <el-form
          :model="data"
          label-position="left"
          size="mini"
          label-width="120px"
        >
          <h2>{{ data.Name }}</h2>
          <div class="tags">
            <el-tooltip
              effect="dark"
              content="Clasificacion"
              placement="top-start"
              size="mini"
              :disabled="!data.Clasification"
            >
              <el-tag type="success" v-if="data.Clasification" size="mini">{{
                data.Clasification
              }}</el-tag>
            </el-tooltip>

            <el-tooltip
              effect="dark"
              content="Estatus"
              placement="top-start"
              :disabled="!data.Status"
              size="mini"
            >
              <el-tag type="success" v-if="data.Status" size="mini">{{
                data.Status
              }}</el-tag>
            </el-tooltip>

            <el-tooltip
              effect="dark"
              content="Dias de crédito"
              placement="top-start"
              :disabled="!data.PaymentDay"
              size="mini"
            >
              <el-tag type="success" v-if="data.PaymentDay" size="mini">{{
                data.PaymentDay
              }}</el-tag>
            </el-tooltip>

            <el-tag size="mini">{{ data.ClientType }}</el-tag>

            <el-tooltip
              placement="top-start"
              :content="
                data.ContractStatus >= 1
                  ? 'Contrato del cliente abierto'
                  : 'Contrato del cliente cerrado'
              "
            >
              <el-tag
                :type="data.ContractStatus >= 1 ? 'success' : 'danger'"
                size="mini"
                >CN</el-tag
              >
            </el-tooltip>

            <template v-if="currentCompany === companys.MTR">
              <el-tooltip
                :content="
                  data.StatusNavixy
                    ? 'Servicio en Plataforma activo'
                    : 'Servicio en Plataforma desactivado'
                "
                placement="top-start"
                effect="dark"
              >
                <el-tag
                  :type="data.StatusNavixy ? 'success' : 'danger'"
                  size="mini"
                  >SP</el-tag
                >
              </el-tooltip>
            </template>

            <template v-if="data.OverdueBillsQty > 0">
              <el-tooltip
                content="Facturas vencidas"
                placement="top-start"
                effect="dark"
              >
                <el-tag type="danger" size="mini"
                  >FV: {{ data.OverdueBillsQty }}</el-tag
                >
              </el-tooltip>
            </template>
          </div>
          <hr />

          <el-row :gutter="20" type="flex column">
            <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
              <el-form-item label="Codigo">
                <el-input v-model="data.ClientCode" :disabled="true"></el-input>
              </el-form-item>

              <el-form-item label="RNC">
                <el-input
                  v-model="data.VatRegistrationNumber"
                  :disabled="true"
                />
              </el-form-item>

              <el-form-item label="Telefono">
                <el-input v-model="phone" :disabled="true"></el-input>
              </el-form-item>

              <el-form-item label="Vendedor">
                <el-input
                  v-model="data.SalesPersonName"
                  :disabled="true"
                ></el-input>
              </el-form-item>

              <el-form-item label="Servicio">
                <el-input
                  v-model="data.CustomerService"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
              <el-form-item label="Email">
                <el-input v-model="data.Email" :disabled="true"></el-input>
              </el-form-item>

              <el-form-item label="Direccion">
                <el-input v-model="data.Address" :disabled="true"></el-input>
              </el-form-item>

              <el-form-item label="Ciudad">
                <el-input v-model="data.City" :disabled="true"></el-input>
              </el-form-item>

              <el-form-item label="Zona">
                <el-input v-model="data.Zone" :disabled="true"></el-input>
              </el-form-item>

              <el-form-item label="Gestor de Cobro">
                <el-input
                  v-model="data.AccountReceivable"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
              <el-form-item label="# Empleados">
                <el-input
                  v-model="data.EmployeesQuantity"
                  :disabled="true"
                ></el-input>
              </el-form-item>

              <el-form-item label="# Computadoras">
                <el-input v-model="data.PcQuantity" :disabled="true"></el-input>
              </el-form-item>

              <el-form-item label="# Vehiculos">
                <el-input
                  v-model="data.VehiclesQuantity"
                  :disabled="true"
                ></el-input>
              </el-form-item>

              <el-form-item label="# Clientes">
                <el-input
                  v-model="data.ClientQuantity"
                  :disabled="true"
                ></el-input>
              </el-form-item>
              <el-form-item label="Solicitudes Bloqueadas">
                <BlockUnblockSomeRequestTypes
                  :ClientCode="CustomerData.ClientCode"
                  :IsItBlocked="IsItBlocked"
                  @LockChanged="onLockChange"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row class="mt-20">
            <el-col>
              <el-tabs
                v-model="activeName"
                :before-leave="onBeforeLeave"
                @tab-click="clickTab"
              >
                <el-tab-pane label="Contactos" name="contacts">
                  <TableContacts
                    v-if="activeName === 'contacts'"
                    ref="contacts"
                    :clientCode="data.ClientCode"
                  />
                </el-tab-pane>
                <el-tab-pane label="Interacciones" name="interactions">
                  <TableInteractions
                    v-if="activeName === 'interactions'"
                    ref="interactions"
                    :clientCode="data.ClientCode"
                    :CustomerData="CustomerData"
                  />
                </el-tab-pane>
                <el-tab-pane label="Soportes" name="supports">
                  <TableSupports
                    v-if="activeName === 'supports'"
                    ref="supports"
                    :clientCode="data.ClientCode"
                  />
                </el-tab-pane>
                <el-tab-pane label="Estado de cuenta" name="account_status">
                  <TableAccountStatus
                    v-if="activeName === 'account_status'"
                    ref="account_status"
                    :clientCode="data.ClientCode"
                  />
                </el-tab-pane>
                <el-tab-pane label="Contrato Navision" name="contracts">
                  <el-badge
                    slot="label"
                    :value="this.totalContractNavisionByClient"
                  >
                    <span>Contratos</span>
                  </el-badge>
                  <TableContracts
                    v-if="activeName === 'contracts'"
                    ref="contracts"
                    :clientCode="data.ClientCode"
                  />
                </el-tab-pane>
                <!-- <el-tab-pane
                      label="Quejas o reclamaciones"
                      name="complaints"
                    >
                      <rabbey-table
                        ref="complaints"
                        index-url="/api/contacts/GetContactByCustomerCode"
                        @get:data="getComplaints"
                        :headers="columnComplaints"
                        :height="400"
                      />
                    </el-tab-pane> -->
                <el-tab-pane label="Equipos en Plataforma GPS" name="gps">
                  <!--v-if="currentCompany === companys.MTR"-->
                  <el-badge slot="label" :value="total_gps_by_user">
                    <span>Equipos de GPS en Plataforma</span>
                  </el-badge>

                  <TableGpsStatus
                    v-if="activeName === 'gps'"
                    ref="gps"
                    :clientCode="data.ClientCode"
                  />
                </el-tab-pane>
                <el-tab-pane
                  label="Equipos en Plataforma Terminales"
                  name="terminales"
                >
                  <!--v-if="currentCompany === companys.MTR"-->
                  <el-badge slot="label" :value="totalterminales">
                    <span>Equipos de Terminales en Plataforma</span>
                  </el-badge>

                  <TableTerminalesStatus
                    v-if="activeName === 'terminales'"
                    ref="terminales"
                    :clientCode="data.ClientCode"
                  />
                </el-tab-pane>
                <el-tab-pane label="Documentos" name="Clients_documents">
                  <el-row>
                    <el-col :span="6" :offset="0">
                      <CustomersFilesUploader
                        UploadHeader="Contratos"
                        :DocumentType="1"
                        :CustomerCode="data.ClientCode"
                      />
                    </el-col>
                    <el-col :span="6" :offset="0">
                      <CustomersFilesUploader
                        UploadHeader="Registro Mercantil"
                        :DocumentType="2"
                        :CustomerCode="data.ClientCode"
                      />
                    </el-col>
                    <el-col :span="6" :offset="0">
                      <CustomersFilesUploader
                        UploadHeader="Cedula"
                        :DocumentType="3"
                        :CustomerCode="data.ClientCode"
                      />
                    </el-col>
                    <el-col :span="6" :offset="0">
                      <CustomersFilesUploader
                        UploadHeader="Otros Documentos"
                        :DocumentType="4"
                        :CustomerCode="data.ClientCode"
                      />
                    </el-col>
                  </el-row>
                </el-tab-pane>
                <!-- YOOO -->
                <el-tab-pane label="Cartas" name="Clients_cards">
                  <rabbey-toolbox
                    :filterables="true"
                    @filter-search="onFilterSearch"
                  ></rabbey-toolbox>
                  <div>
                    <vue-scroll class="page-dashboard">
                      <rabbey-toolbox :call-new="callNew" />
                      <el-row>
                        <el-col>
                          <rabbey-table3
                            ref="table"
                            :stripe="true"
                            :data="items"
                            :columns="columns"
                            :actions="actions"
                            :loading="loading"
                            @rtable-push-action="actionHandler"
                            @update-page-size="updatePageSize"
                            @update-current-page="updateCurrentPage"
                          />
                        </el-col>
                      </el-row>
                    </vue-scroll>
                    <el-dialog
                      title="Subir cartas"
                      :visible.sync="drawerCards"
                      width="30%"
                    >
                      <div id="div-legal">
                        <CustomersFilesUploader
                          :Visible="drawerCards"
                          UploadHeader="Cartas"
                          :DocumentType="6"
                          :CustomerCode="data.ClientCode"
                        />
                      </div>
                      <span slot="footer" class="dialog-footer">
                        <el-button v-on:click="closeDrawerCars"
                          >Cancel</el-button
                        >
                        <el-button type="primary" v-on:click="closeDrawerCars"
                          >Confirm</el-button
                        >
                      </span>
                    </el-dialog>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </rabbey-base-drawer>
</template>

<script>
import { COMPANYS } from "@/const";
import { formatPhoneNumber } from "@/utils";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import TableAccountStatus from "./TableAccountStatus.vue";
import TableInteractions from "./TableInteractions.vue";
import TableSupports from "./TableSupports.vue";
import TableContracts from "./TableContracts.vue";
import TableContacts from "./TableContacts.vue";
import TableGpsStatus from "./TableGpsStatus.vue";
import TableTerminalesStatus from "./TableTerminalesStatus.vue";
import CustomersFilesUploader from "./CustomersFilesUploader.vue";
import BlockUnblockSomeRequestTypes from "@/components/requests/BlockUnblockSomeRequestTypes";

export default {
  name: "CustomerDetail",
  inheritAttrs: false,
  components: {
    TableAccountStatus,
    TableInteractions,
    TableSupports,
    TableContracts,
    TableContacts,
    TableGpsStatus,
    CustomersFilesUploader,
    TableTerminalesStatus,
    BlockUnblockSomeRequestTypes
  },
  props: {
    CustomerData: {
      type: Object
    },
    ChangeActiveName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      companys: COMPANYS,
      activeColapseName: ["1"],
      data: {},
      drawer: false,
      drawerCards: false,
      titleRow: "Detalle de cliente",
      loading: false,
      activeName: "contacts",
      totalContractNavisionByClient: 0,
      totalterminales: 0,
      contractNo: "",
      UploadHeader: "",
      currentPage: 1,
      pageSize: 10,
      title: "",
      invoicespending: [],
      NcfStatu: {},
      dialogVisible: false,
      items: [],
      IsItBlocked: true,
      columns: [
        {
          prop: "idClient",
          label: "Cliente code",
          width: 130,
          sortable: true
        },
        {
          prop: "id",
          label: "NO",
          width: 130,
          sortable: true
        },
        {
          prop: "name",
          label: "Descripcion",
          width: 220,
          sortable: true
          // sortable: true,
          // formatter: row => {
          //   return row.ISODocumentProcess.Name;
          // }
        },
        // {
        //   prop: "url",
        //   label: "Url del archivo",
        //   sortable: true,
        // },
        // {
        //   prop: "uid",
        //   label: "Uid del archivo",
        //   sortable: true
        // },
        {
          prop: "date",
          label: "Fecha de creacion",
          width: 150,
          sortable: true,
          formatter: DatetimeFormatter
        }
      ],
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view"
        },
        {
          icon: "el-icon-delete",
          label: "Eliminar",
          command: "delete"
        }
      ]
    };
  },
  methods: {
    formatPhoneNumber,
    // eslint-disable-next-line no-unused-vars
    onBeforeLeave(activeName, oldActiveName) {
      this.activeName = activeName;

      if (activeName === "gps") {
        this.$nextTick(() => {
          this.$refs.gps.getItems(this.data.ClientCode);
        });
      } else {
        this.$nextTick(() => {
          this.$refs.terminales.getItems2(this.data.VatRegistrationNumber);
        });
      }
      this.activeName = "contacts";
    },
    onFilterSearch(query) {
      this.$refs.table.filterData(query);
      this.GetDocuments();
      return;
    },
    clickTab(tab) {
      if (tab.label === "Cartas") {
        this.GetDocuments();
      }
    },
    async GetDocuments() {
      const Api = "/api/customers/getCustomersDocuments";
      //const params = `/EmployeeId=${EmployeeId}&DocumentType=${DocumentType}`;

      const params = {
        params: {
          CustomerCode: this.data.ClientCode,
          DocumentType: 6,
          IsEaneable: true
        }
      };
      this.items = []; //vaciar el array cuando sea llamado nuevamente
      await this.$http
        .get(Api, params)
        .then((resp) => {
          let { data } = resp;
          data.forEach((doc) => {
            this.items.push({
              idClient: doc.CustomerCode,
              id: doc.DocumentId,
              name: doc.DocumentName,
              url: doc.DocumentUrl,
              uid: doc.DocumentUid,
              date: doc.CreatedAt
            });
          });
        })
        .catch((err) => {
          console.error(
            `${err.name}:  ${err.message} `,
            "\n Error Detail: ",
            err
          );
          /*
          this.$message({
            type: "error",
            message: `${err.name}:  ${err.message} `,
            center: true
          });
          */
        })
        .finally(() => {});
    },
    actionHandler(action) {
      switch (action.command) {
        case "view": {
          let link = document.createElement("a");
          link.href = action.row.url;
          link.target = "_blank";
          link.click();
          break;
        }
        case "delete": {
          this.$confirm(
            "This will permanently delete the file. Continue?",
            "Warning",
            {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "warning"
            }
          )
            .then(() => {
              const Api = "/api/customers/disableCustomersDocuments";

              const params = {
                CustomerCode: action.row.idClient,
                DocumentType: 6,
                DocumentName: action.row.name,
                DocumentUrl: action.row.url,
                DocumentUid: action.row.uid,
                IsEaneable: false
              };
              this.$http
                .put(Api, params)
                .then((resp) => {
                  let { DocumentName } = resp.data;
                  this.$message({
                    showClose: true,
                    message: `Se ha eliminado el archivo "${DocumentName}" satisfactoriamente`,
                    type: "success",
                    center: true,
                    offset: 30
                  });
                  this.GetDocuments();
                })
                .catch((err) => {
                  this.$message({
                    type: "error",
                    message: `${err.name}:  ${err.message} `,
                    center: true
                  });
                })
                .finally(() => {});
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "Se ha cancelado el borrado del documento"
              });
              this.items = [];
              this.GetDocuments();
            });
          break;
        }
      }
    },
    updatePageSize(val) {
      this.pageSize = val;
      this.GetDocuments();
      this.getItems();
    },
    updateCurrentPage(val) {
      this.currentPage = val;
      this.GetDocuments();
    },
    async show(data) {
      this.IsItBlocked = this.CustomerData.ServiceRequestsBlocked;
      this.data = data;
      this.activeName = "contacts";
      this.drawer = true;

      this.CountContractByClient();
      this.getterminales();
      this.getItemsAccountStatus();
      this.getstatusplataforma();
      // Encargado de buscar el total de gps para el badge
      await this._fetchGpsQty();

      this.$nextTick(() => {
        this.$refs.contacts.getItems();
      });
    },
    async _fetchGpsQty() {
      if (this.currentCompany === this.companys.TB) {
        const userId = await this.$store.dispatch("navixy/searchUserId", {
          client_code: this.data.ClientCode
        });

        await this.$store.dispatch("navixy/reportGps12H", { sid: userId });
      }
    },

    async CountContractByClient() {
      this.$http
        .get("/api/contracts/GetContratsCount", {
          timeout: 999999,
          params: {
            clientCode: this.data.ClientCode,
            companyCode: this.currentCompany
          }
        })

        .then(({ data }) => {
          this.totalContractNavisionByClient = data.length;
        })
        .catch((error) => {
          this.$message.error("Error al consultar los contratos");
          console.error(error);
          this.contractNo = 0;
        });
    },

    OnClose() {
      this.ChangeActiveName = "";
      this.$store.dispatch("navixy/set_total_gps_by_user_to_default");
      this.drawerCards = false;
    },
    callNew() {
      this.title = "Nueva carta cliente";
      this.drawerCards = true;
    },
    closeDrawerCars() {
      this.GetDocuments();
      this.drawerCards = false;
    },
    getterminales() {
      this.$http
        .get("/api/tennos/GetTerminales", {
          params: {
            rnc: this.data.VatRegistrationNumber
          }
        })
        .then((response) => {
          this.totalterminales = response.data.length;
        })
        .catch((error) => console.error(error))
        .finally(() => (this.loading = false));
    },
    getItemsAccountStatus() {
      this.loading = true;
      this.items = [];
      this.$http
        .get("/api/invoices/InvoicesPending", {
          timeout: 3 * 60 * 1000, // Espera hasta 3 minutos
          params: {
            "criteria.clientCode": this.data.ClientCode,
            "criteria.companyCode": this.currentCompany,
            "criteria.opc": 1
          }
        })
        .then(({ data }) => {
          const currentDate = new Date();
          currentDate.setHours(0, 0, 0, 0);
          this.invoicespending = data.filter(
            (c) => c.CustomerNo === this.data.ClientCode
          );
          var invoiceQtys = this.invoicespending.map(function (invoice) {
            return invoice.InvoiceQty;
          });

          this.invoicespending = invoiceQtys[0];
        })
        .catch((error) => {
          this.$message.error("Error al consultar el estado de cuenta");
          console.error(error);
          this.items = [];
        })
        .finally(() => {
          this.loading = false;
          this.$refs.table.doLayout();
        });
    },

    getstatusplataforma() {
      this.loading = true;
      this.$http
        .get("/api/tennos/StatusPlataforma", {
          params: {
            rnc: this.data.VatRegistrationNumber
          }
        })
        .then(({ data }) => {
          this.NcfStatu = data;
        });
    },

    async onLockChange(value) {
      await this.$http
        .put("/api/customers/BlockUnblockSomeRequestTypes", {
          IsBlocked: value,
          ClientCode: this.data.ClientCode
        })
        .then(() => {
          this.IsItBlocked = value;
          this.$emit("RechargeCustomerData");
        });
    }
  },

  computed: {
    phone() {
      return this.formatPhoneNumber(this.data.PhoneNumber);
    },
    total_gps_by_user() {
      return this.$store.state.navixy.total_gps_by_user;
    },
    totalContractNavisionComputed() {
      return this.totalContractNavisionByClient;
    }
    // totalterminales() {
    //   return this.totalterminales;
    // }
  },
  watch: {
    ChangeActiveName() {
      if (this.ChangeActiveName != "") {
        this.activeName = this.ChangeActiveName;
        this.ChangeActiveName = "";
      }
    },
    CustomerData(value) {
      this.IsItBlocked = value.ServiceRequestsBlocked;
    }
  }
};
</script>

<style lang="scss">
.el-tabs__nav-scroll {
  .el-badge__content {
    &.is-fixed {
      top: 10px !important;
      right: 0px !important;
    }
  }
}

.tags span:not(:first-child) {
  margin-left: 5px;
}

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}
.statustags span:not(:first-child) {
  margin-left: 5px;

  top: 12%;
}
.statustags {
  margin-left: 40%;
  top: 15%;
}
</style>
